<div class="datatable-super-upper-wrap">
  <div class="col-settings-wrapper">
    <!--<div  (click)="toggleColumnSettings()">
      <i  class="fas fa-cog"></i>
    </div>
    <div class="column-settings-wrapper" *ngIf="showColumnSettings">
      <div *ngFor="let col of columnMapping">
        <label class="form-checkbox">
          <input
            (click)="toggleColumn(col)"
            [(ngModel)]="!col.disabled"
            type="checkbox"
          />
          <i class="form-icon"></i> {{ col.name }}
        </label>
      </div>
    </div>-->
  </div>
  <div class="datatable-upper-wrap" *ngIf="showTable">
    <ngx-datatable
      #datatable
      class="material striped custom-ngx-dt"
      [rows]="rows"
      [loadingIndicator]="loadingIndicator"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="footerHeight"
      [rowHeight]="'auto'"
      (directiveDrop)="onDrop($event)"
      [classSelector]="dragEnabled && canReorder ? 'fas fa-grip-horizontal' : 'drag-disabled'"
      [dragulaName]="'bag'"
      [dragulaModel]="rows"
      [externalSorting]="false"
      [sorts]="sorts"
      (sort)="[]"
      [messages]="{ emptyMessage: 'TABLE.NO_DATA' | translate }"
    >
      <ngx-datatable-column *ngIf="dragEnabled && canReorder" [maxWidth]="25">
        <ng-template
          ngx-datatable-cell-template
          let-rowIndex="rowIndex"
          let-value="value"
          let-row="row"
        >
          <a class="grab-btn" *ngIf="editingItemCount == 0">
            <i class="fas fa-grip-horizontal"></i>
          </a>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        *ngFor="let col of columns"
        [name]="col.name | translate"
        [prop]="col.prop"
        [maxWidth]="col.maxWidth"
        [sortable]="col.sortable" [sortable]="false"
      >
        <ng-template
          ngx-datatable-cell-template
          let-rowIndex="rowIndex"
          let-value="value"
          let-row="row"
        >
          <div *ngIf="col.prop !== 'actions'">
            <mat-form-field
              *ngIf="isEditable[rowIndex] && col.prop !== 'priority'"
            >
              <input matInput [(ngModel)]="row[col.prop]" />
            </mat-form-field>
            <span *ngIf="!isEditable[rowIndex] || col.prop === 'priority'">{{
              value
            }}</span>
          </div>
          <div class="action-list-custom" *ngIf="col.prop === 'actions'">
            <div class="action-item" *ngFor="let a of actionItems">
              <div [ngSwitch]="a.toolTipText" *ngIf="shouldShowAction(a)">
                <div *ngSwitchCase="'GENERIC.EDIT' | translate"
                     class="edit-button-wrapper">
                  <button
                    (click)="onEdit(rowIndex)"
                    class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                    [attr.data-tooltip]="a.toolTipText | translate"
                    *ngIf="!isEditable[rowIndex]"
                  >
                    <i class="{{ a.iconClass }}"></i>
                  </button>

                  <button
                    *ngIf="isEditable[rowIndex]"
                    class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left save-button"
                    [attr.data-tooltip]="'GENERIC.SAVE' | translate"
                    (click)="
                      saveData(row, rowIndex);
                      editingItemCount = editingItemCount - 1
                    "
                  >
                    <i class="fas fa-check"></i>
                  </button>
                  <button
                    (click)="onCancelEdit(rowIndex)"
                    class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                    [attr.data-tooltip]="'GENERIC.CANCEL' | translate"
                    *ngIf="isEditable[rowIndex]"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>

                <button
                  *ngSwitchDefault
                  (click)="onActionClick(a, row.id)"
                  class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                  [attr.data-tooltip]="a.toolTipText | translate"
                >
                  <i class="{{ a.iconClass }}"></i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
